import axios from 'axios';
import { useCookies } from 'vue3-cookies';

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_API_SERVER_URL}`,
});

instance.interceptors.request.use(
  function (config) {
    const { cookies } = useCookies();
    const previewerAccessToken = cookies.get('previewerAccessToken');
    if (previewerAccessToken && config.headers) {
      config.headers.Authorization = `Bearer ${previewerAccessToken}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

/*
    2. 응답 인터셉터를 작성합니다.
    2개의 콜백 함수를 받습니다.

    1) 응답 정성 - 인자값: http response
    2) 응답 에러 - 인자값: http error
*/
instance.interceptors.response.use(
  function (response) {
    /*
        http status가 200인 경우
        응답 바로 직전에 대해 작성합니다. 
        .then() 으로 이어집니다.
    */
    return response;
  },

  function (error) {
    /*
        http status가 200이 아닌 경우
        응답 에러 처리를 작성합니다.
        .catch() 으로 이어집니다.    
    */
    return Promise.reject(error);
  }
);

// 생성한 인스턴스를 익스포트 합니다.
export default instance;
